import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import IconButton from '@mui/material/IconButton';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import AvatarPreview from '../AvatarPreview';
import { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

const ImageUploadContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  width: '380px',
  maxHeight: '620px',
  gap: '45px',
  [theme.breakpoints.down('md')]: {
    gap: '40px',
    alignItems: 'center',
    width: '366px',
  },
}));

const ImageUploadForm = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '380px',
  height: '380px',
  backgroundColor: '#E0E0E0',
  boxShadow: '0 2px 2px rgba(0, 0, 0, 0.3)',
  [theme.breakpoints.down('md')]: {
    width: '360px',
    height: '346px',
  },
}));

const DragAndClickLabel = styled('label')(({ theme }) => ({
  display: 'flex',
  width: '352px',
  height: '356px',
  margin: 'auto',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px dashed #999999',
  [theme.breakpoints.down('md')]: {
    width: '332px',
    height: '316px',
  },
}));

const DragAndClickBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
}));

const TextTypography = styled(Typography)(() => ({
  fontFamily: 'Raleway',
  fontWeight: '400',
  fontSize: '20px',
  lineHeight: '23px',
  display: 'flex',
  alignItems: 'center',
  color: '#717171',
}));

export default function AvatarUpload() {
  const [selectedImages, setSelectedImages] = useState(false);
  const imagePreview = (selectedFiles, setSelectedImages) => {
    if (selectedFiles.length > 0) {
      const selectedFilesArray = Array.from(selectedFiles);
      const imagesArray = selectedFilesArray.map((image) => {
        return URL.createObjectURL(image);
      });
      if (imagesArray.length > 1) {
        alert('Cannot upload image more than 1');
        return;
      }
      setSelectedImages(imagesArray);
    }
    return;
  };

  const OnSelectFile = (e) => {
    e.preventDefault();
    const selectedFiles = e.target.files;
    imagePreview(selectedFiles, setSelectedImages);
    e.target.value = null;
  };

  const dragOver = (e) => e.preventDefault();
  const dragEnter = (e) => e.preventDefault();
  const dragLeave = (e) => e.preventDefault();
  const fileDrop = (e) => {
    e.preventDefault();
    const selectedFiles = e.dataTransfer.files;
    imagePreview(selectedFiles, setSelectedImages);
  };

  const selectDeleted = () => {
    setSelectedImages('');
  };

  const mobileMatch = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <ImageUploadContainer>
      {!mobileMatch ? (
        <AvatarPreview images={selectedImages} deleteHandler={selectDeleted} />
      ) : selectedImages ? (
        <AvatarPreview images={selectedImages} deleteHandler={selectDeleted} />
      ) : null}

      <ImageUploadForm
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
      >
        <input hidden type="file" id="input-file-upload" multiple={true} onChange={OnSelectFile} />
        <DragAndClickLabel id="label-file-upload" htmlFor="input-file-upload">
          <DragAndClickBox>
            <IconButton aria-label="upload picture" component="label">
              <input hidden accept="image/*" type="file" multiple={true} onChange={OnSelectFile} />
              <AddPhotoAlternateIcon sx={{ fontSize: 34 }} />
            </IconButton>
            <TextTypography>Drag and drop or click to upload</TextTypography>
          </DragAndClickBox>
        </DragAndClickLabel>
      </ImageUploadForm>
    </ImageUploadContainer>
  );
}
